{
    "retry": "Try again",
    "widget_error": {
        "unexpected": "Something went wrong.",
        "load": "Something went wrong. We couldn't load this information. Please try again.",
        "confirmation": "Something went wrong. We couldn't load your confirmation. Your booking may already have been saved.",
        "action": "Something went wrong. We couldn't confirm whether this action completed. Please check its status before trying again.",
        "dismiss": "Dismiss"
    },
    "currencySymbol": "$",
    "currencyPattern": "!#",
    "negativeCurrencyPattern": "!-#",
    "decimalSeparator": ",",
    "thousandSeparator": ".",
    "locale": "en",
    "search": "Search",
    "search_no_data_to_display": "No records found",
    "something_went_wrong": "Something went wrong",
    "poweredBy": "Powered By <img src=\"{apiBaseUrl}\/butlerapp_icon.png\" alt=\"Kursverwaltung, Buchungssystem und Seminarverwaltung von Butlerapp\"> Butlerapp",
    "recommended_consent": {
        "title": "<h4>Recommended</h4>",
        "description": "<p>Most users prefer selecting this consent</p>"
    },
    "admin_settings": {
        "label": "Options"
    },
    "authentication": {
        "booking_returning_prompt": "Booked with us before?",
        "booking_login_link": "Get a sign-in link by email",
        "back_to_booking": "Back to booking",
        "check_your_email": "Check your email",
        "auth_link_sent_to": "We've sent a sign-in link to {email}.",
        "open_email_to_book": "Open the email and click the link to continue your booking.",
        "open_email_to_sign_in": "Open the email and click the link to sign in.",
        "sign_in_header": "Sign in",
        "send_sign_in_link": "Send sign-in link",
    "magic_link_description": "Enter your email address and we'll send you a magic link to sign in. No password needed.",
        "sign_in": "Sign in",
        "email": "Email",
        "resend": "Resend",
        "auth_link_sent": "A link has been sent to the provided email. {resend}",
        "preview": {
            "sign_in": "Sign in",
            "user": "{ name } { dueAmount }",
            "due_amount_empty": "{dueAmount}",
            "sign_out": "Sign out",
            "my_account": "Account"
        }
    },
    "user_entity": {
        "vouchers": {
            "title": "Voucher",
            "code": "Voucher code",
            "remaining": "Remaining balance",
            "valid_from": "Valid from",
            "valid_until": "Valid until",
            "no_expiry": "No expiry",
            "uses": "{count} uses remaining",
            "uses_one": "{count} use remaining",
            "description": "These vouchers are automatically applied to eligible bookings when you are signed in.",
            "status": "Status",
            "status_active": "Active",
            "status_partially_used": "Partially used",
            "status_exhausted": "Used up",
            "status_not_yet_valid": "Not yet valid",
            "status_expired": "Expired",
            "status_voided": "Cancelled",
            "status_pending_activation": "Pending activation",
            "status_waitlist": "Waitlist"
        },
        "no_data_to_display": "Unfortunately no records were found.",
        "tabs": {
            "vouchers": "My Vouchers",
            "payments": "Payments",
            "bills": "Bills",
            "messages": "Messages",
            "bookings": "Bookings"
        },
        "bookings": {
            "booking_id": "Booking Id",
            "full_name": "Full Name",
            "timespan": "Event Name",
            "cancel_link": "",
            "cancel_booking_button": "{icon}",
            "cancel_booking": "Cancel",
            "due_amount": "Due Amount",
            "bills": "Bills",
            "download_bill": "{icon} {billId}",
            "download_bill_title": "Download #{billId}",
            "from_to_auto": "{fromDate} {fromTime} {toDate} {toTime}",
            "course": "Course",
            "place": "$t(course_table.places)",
            "show_more": "$t(course_table.show_more)",
            "show_less": "$t(course_table.show_less)",
            "more_info": "$t(course_table.more_info)",
            "course_format": "$t(course_table.course_format)",
            "from_to_time": "$t(course_table.from_to_time)",
            "appointment_list": "$t(course_table.appointment_list)",
            "appointments": "$t(course_table.appointments)",
            "information": "$t(course_table.information)",
            "timespan_format": "{course1} {course2} { title }",
            "waitlist": "waitlist",
            "status": "Status",
            "due_date": "due on {dueDate}",
            "summary": {
                "next_appointment": "Next appointment: {title} {dateTime}",
                "due_amount": "Total Due amount: {dueAmount}"
            }
        },
        "bills": {
            "bill_id": "Bill Id",
            "due_amount": "Due Amount",
            "price": "Price",
            "download": "",
            "download_link": "Download Bill",
            "status": "Status"
        },
        "payments": {
            "bill_id": "Bill Id",
            "finalized_at": "Finalized At",
            "payment_type": "Payment Type",
            "payment_amount": "Payment Amount"
        }
    },
    "page_titles": {
        "title": "{ cartCount } {prefix} {pageTitle} {postfix}",
        "prefix": "",
        "postfix": "",
        "cart_count": "({ count })",
        "bookcart": "Booking form",
        "courses": "Courses",
        "success": "Booking success",
        "paybook": "Payment page",
        "payment_approved": "Payment Approved",
        "payment_cancelled": "Payment Cancelled",
        "consents": "Consents",
        "banktransfer": "Bank transfer",
        "sepadirectdebit": "Sepa Mandate",
        "cart": "Cart",
        "checkout": "Checkout"
    },
    "date": {
        "year": "Year",
        "month": "Month",
        "date": "Date",
        "to_date_separator": "-",
        "today": "Today",
        "tomorrow": "Tomorrow"
    },
    "browser_not_supported": "Browser is not supported",
    "fallback_error_message": "A technical error occurred while processing your request. We are sorry. Our technical team has already been informed and is working on the solution to the problem.",
    "drag_and_drop_hint": "Drag & drop a file here, or click to select a file",
    "drag_and_drop_hint_multiple": "Drag & drop files here, or click to select files.",
    "bank_transfer": {
        "bank_name": "Bank",
        "owner": "Account Owner",
        "iban": "IBAN",
        "bic": "BIC",
        "billAmount": "Amount",
        "payment_purpose": "Payment Purpose",
        "payment_purpose_value": "{ paymentPurpose } <strong>(please always provide this in all bank transfers)</strong>",
        "title": "Pay by online transfer",
        "intro": "Please transfer { amount } via online banking without deductions to the following account and state <strong>{ paymentPurpose }</strong> as the purpose."
    },
    "admin_config_toggles": {
        "allow_all_events": "Allow all events",
        "is_validation_unstrict": "Disable validation",
        "disable_customer_personal_data": "Unlock customer data",
        "without_billing": "Without Billing",
        "not_send_bills": "Don't send bills",
        "not_send_bookings": "Don't send bookings",
        "draft_bills": "Draft bills",
        "draft_bookings": "Draft bookings",
        "waitlist_bookings": "Waitlist bookings"
    },
    "admin_config_toggle_descriptions": {
        "allow_all_events": "",
        "is_validation_unstrict": "",
        "disable_customer_personal_data": "",
        "without_billing": "",
        "not_send_bills": "",
        "not_send_bookings": "",
        "draft_bills": "",
        "draft_bookings": "",
        "waitlist_bookings": ""
    },
    "admin_booking_form": {
        "title": "+ Booking",
        "all_timespans_booked_out_hint": "Enable {option} below to book a fully booked or past event.",
        "employee_consents": "Employee Consents",
        "user_consents": "User Consents",
        "book_now_disabled": {
            "loading": "Loading, Please wait.",
            "select_a_customer": "Please select a customer for quick booking",
            "participant_count_mismatch": "For a quick booking, the number of people booked should be equal to the number of participants available",
            "more_participant_information_required": "More participant information is required",
            "cannot_quick_book": "Unable to quick book at the moment"
        },
        "add_to_cart": "$t(cart.add_to_cart)",
        "book_now": "$t(cart.book_now)",
        "continue": "$t(cart.continue)",
        "checkout": "$t(cart.checkout)",
        "express": "Express"
    },
    "modal": {
        "confirm_abandon": "Do you really want to abandon your booking?",
        "confirm_close": "Do you really want to close this popup?"
    },
    "written_consent": {
        "download_link_label": "Download",
        "title_checked": "I accept that I have written consent from the user to make this booking {downloadConsentsFormLink}",
        "description_checked": "A written consent is required when making a booking on behalf the customer",
        "title_unchecked": "",
        "description_unchecked": ""
    },
    "bookcart": {
        "title": "",
        "popup_form_subtext": "",
        "popup_form_button_fallback": "Book Now",
        "timespan_title": "{course1} {course2} { title } {fromToAuto} {price}",
        "timespan_format": "{course1} {course2} { title } {fromToAuto} {price} {placesLeft}",
        "from_to_auto": "{fromDate} {fromTime} {toDate} {toTime}",
        "no_data_to_display": "Unfortunately no available times were found.",
        "all_timespans_booked_out": "Unfortunately, the desired times are already fully booked.",
        "all_prices_booked_out": "Unfortunately, out of stock.",
        "timespan_booked_out_msg": "Unfortunately, { title } is already fully booked",
        "course_price": "{ price }",
        "course_price_plural": "starts at { price }",
        "place": "Place",
        "place_plural": "Places",
        "course": "Course",
        "course_plural": "Courses",
        "timespan": "Timespan",
        "timespan_plural": "Timespans",
        "new_customer": "Create new customer",
        "participant": "Participant",
        "participant_plural": "Participants",
        "participant_waiting_list": "$t(bookcart.participant) (waiting list)",
        "participant_name": "{title} {first_name} {last_name}",
        "participant_header": "Participant { index }",
        "one_participant_left_waitlist": "A booking with 1 participant will be added to waiting list",
        "card_quantity": {
            "label": "Number of cards",
            "placeholder": "Select number of cards",
            "option": "{quantity} card",
            "option_plural": "{quantity} cards",
            "option_with_price": "$t(bookcart.card_quantity.option) - {amount}"
        },
        "included_uses": "{count} uses included in total",
        "unit_quantity": {
            "label": "Number of units",
            "placeholder": "Select number of units",
            "option": "{quantity} unit",
            "option_plural": "{quantity} units",
            "option_with_price": "$t(bookcart.unit_quantity.option) - {amount}"
        },
        "voucher_quantity": {
            "label": "Number of vouchers",
            "placeholder": "Select number of vouchers",
            "option": "{quantity} voucher",
            "option_plural": "{quantity} vouchers",
            "option_with_price": "$t(bookcart.voucher_quantity.option) - {amount}"
        },
        "step_participant": "{ quantity } $t(bookcart.participant) - { amount }",
        "customer_participant": "{participantName} ({customerName})",
        "step_participant_with_one_price": "{ quantity } $t(bookcart.participant)",
        "biller_participant_header": "Participant and biller",
        "biller_participant_name": "Participant and biller: { first_name } { last_name }",
        "biller_name": "{salutation} { first_name } { last_name }",
        "waitlist": "(waitlist)",
        "biller_header": "Unnamed Bill Recipient: { index }",
        "price": "Price",
        "price_plural": "Prices",
        "n_places_left": "{ count } place left",
        "n_places_left_plural": "{ count } places left",
        "total_amount": "Total Amount",
        "add_separate_bill_recipient": "Add separate invoice recipient",
        "add_separate_bill_recipient_help_text_checked": "You specify a different person or company as the invoice recipient. Deselect \"Add separate invoice recipient\" if you want a participant to receive the invoice.",
        "add_separate_bill_recipient_help_text_unchecked": "The invoice recipient corresponds to the participant listed below. Select \"Separate invoice recipient\" if you want another person or company to receive the invoice.",
        "bill_recipient": "Bill recipient",
        "bill_recipient_help_text": "Select a participant to whom the invoice should be issued.",
        "select_bill_recipient": "Select $t(bookcart.bill_recipient)",
        "next_step": "Next",
        "checkout": "Checkout",
        "submit": "Book",
        "add_to_waiting_list": "Add to waiting list",
        "select_customer": "Filter Customer",
        "complete_booking": "Complete Booking",
        "button_book_for_free": "Book for free",
        "back": "Back",
        "event_selection": "Event Selection",
        "fully_booked": "Fully Booked",
        "price_label": "{price} {title} {quantity_left}",
        "extraprice_label": "{price} {title} {quantity_left}",
        "select_place": "Select Place",
        "select_course": "Select course",
        "select_course_1": "Select top course",
        "select_course_2": "Select sub course",
        "select_timespan": "Select Event",
        "select_price": "Select Price",
        "select_bookers_count": "Select participant count",
        "select_participant_title": "Select/ Create participant",
        "select_participant_placeholder": "Select participant",
        "add_new_participant": "Add New Participant",
        "add_new_bill_recipient": "Add new bill recipient",
        "new_participant": "New Participant",
        "sub_event_help_text": "Please select the participants for this event",
        "enter_participant_information": "Enter Participant Information",
        "timeslots": {
            "date_label": "{ day }, { value }",
            "timeslot_label": "{from}",
            "select_time_slot": "Select a timeslot",
            "select_time_slot_date": "Select a date",
            "select_time_slot_time": "Select a time",
            "select_time_slot_date_placeholder": "Select a date",
            "select_time_slot_time_placeholder": "Select a time",
            "all_timespans_booked_out": "$t(bookcart.all_timespans_booked_out)",
            "only_one_slot_available": "The only available slot { from } has been selected.",
            "filters": {
                "morning": "Morning",
                "afternoon": "Afternoon",
                "evening": "Evening"
            }
        }
    },
    "cart": {
        "title": "<h3>Cart</h3>",
        "timespan_header": "{ timespan_title } { price_title } - { base_price }",
        "no_data_to_display": "No items added to the cart. Please checkout our courses to add items to the cart.",
        "item_no_longer_available": "Item is no longer available.",
        "add_items_to_cart": "Add items to cart",
        "description": "",
        "back": "Back",
        "checkout": "Checkout",
        "continue": "Continue",
        "total": "Total",
        "totalNet": "Total (plus taxes)",
        "modify": "Update",
        "remove": "Remove from cart",
        "add_to_cart": "Add To Cart",
        "from_to_auto": "$t(bookcart.from_to_auto)",
        "course_format": "$t(course_table.course_format)",
        "book_now": "Book now",
        "add_to_cart_icon": "",
        "book_now_icon": "",
        "timespan_format": "$t(bookcart.timespan_format)",
        "item_added_to_cart": "{ title } added to cart",
        "item_added_to_cart_plural": "{ count } items added to cart",
        "item_quantity_left_exceeded": "{ name } already present in the cart {quantity} times. It can be added { difference } times.",
        "register_differing_participants": "Register differing participants",
        "register_differing_participants_help_text_checked": "You register different participants for each event. If you want to register the same participants for all events, deselect \"Different participants\".",
        "register_differing_participants_help_text_unchecked": "You book the same participants for all events. Select \"Different participants\" if you want to register different participants for the events.",
        "preview": {
            "cartText_0": "No Items added",
            "cartText": "{ quantity } Items",
            "label": "<span class=\"{cartWrapClass}\">{cartIcon} { quantity }</span> {total}",
            "quantity": "{quantity}",
            "total": "{total}"
        },
        "item": {
            "title": "Name",
            "price": "Price",
            "quantity": "Quantity",
            "total": "Total"
        }
    },
    "price_summary": {
        "price_breakup": "Summary",
        "price_breakup_collapsed": "Total",
        "total": "Total",
        "timespan_format": "{course1} {course2} { title } {fromToAuto}",
        "from_to_auto": "$t(bookcart.from_to_auto)",
        "waitlist": "(waitlist)",
        "free": "free"
    },
    "common": {
        "select": "Select {label}",
        "ok": "Okay",
        "close": "Close",
        "apply": "Apply",
        "loading": "Loading...",
        "previous": "Previous",
        "next": "Next",
        "finish": "Finish"
    },
    "wizard": {
        "go_to": "Go to: {step}",
        "no_previous_step": "No previous step available",
        "no_next_step": "No next step available"
    },
    "switchable": {
        "yes": "Yes",
        "no": "No"
    },
    "consents": {
        "title": "Consents",
        "submit": "Accept"
    },
    "checkout": {
        "no_data_to_display": "$t(bookcart.no_data_to_display)",
        "timespan_title": "$t(bookcart.timespan_title)",
        "timespan_format": "$t(bookcart.timespan_format)",
        "from_to_auto": "$t(bookcart.from_to_auto)",
        "waitlist": "$t(bookcart.waitlist)"
    },
    "course_categories": {
        "course_format": "$t(course_table.course_format)",
        "timespan_format": "{ title } {fromDate} {fromTime} {toDate} {toTime} {placesLeft} {waitlist}",
        "labels": {
            "title": "Category Name",
            "description": "",
            "booklink": "$t(course_table.book_now)",
            "next_course_timespan": "Next course timespan:"
        }
    },
    "course_table": {
        "title": "",
        "free": "",
        "course_format": "{title}",
        "course_price": "$t(bookcart.course_price)",
        "course_price_plural": "$t(bookcart.course_price_plural)",
        "timespan_title": "{course1} {course2} { title } {fromDate} {fromTime} {price}",
        "timespan_format": "{course1} {course2} { title } {fromDate} {fromTime} {toDate} {toTime} {price} {placesLeft}",
        "from_to_auto": "{fromDate} {fromTime} {toDate} {toTime}",
        "from_to_time": "{fromTime} - {toTime}",
        "appointments": "Appointments",
        "show_more": "Show {count} more",
        "show_less": "Show less",
        "appointment_list": "Appointments",
        "from_date_auto": "{fromDate} {fromTime} {toTime}",
        "from_date": "{fromDateAuto}",
        "to_date": "{toDate} {toTime}",
        "trainer": "Trainer",
        "trainer_name": "{firstName} {lastName}",
        "no_data_to_display": "$t(bookcart.no_data_to_display)",
        "no_data_to_display_in_current_page": "No bookable records exist on this page, please navigate to another page.",
        "places": "Place",
        "event": "Event",
        "from": "Beginning",
        "to": "Ends at",
        "offer": "Offer",
        "from_date_header": "From Date",
        "to_date_header": "To Date",
        "from_time": "From Time",
        "to_time": "To Time",
        "duration": "Duration",
        "categories": "Categories",
        "information": "Information",
        "remaining": "Places left",
        "n_places_left": "{ count } place left",
        "n_places_left_plural": "{ count } places left",
        "price": "$t(bookcart.price)",
        "book_now": "Book now",
        "add_to_waiting_list": "Add to waiting list",
        "more_info": "More Info",
        "pagination_total": "{from} - {to} of {totalRecords} records",
        "no_appointments": "No Appointments",
        "fully_booked": "Fully Booked",
        "pagination": {
            "items_per_page": "/ page",
            "jump_to": "Go to",
            "jump_to_confirm": "confirm",
            "next_3": "Next 3 Pages",
            "next_5": "Next 5 Pages",
            "next_page": "Next Page",
            "page": "Page",
            "prev_3": "Previous 3 Pages",
            "prev_5": "Previous 5 Pages",
            "prev_page": "Previous Page"
        }
    },
    "offers": {
        "columns": {
            "appointments": "$t(course_table.appointments)",
            "appointment_list": "$t(course_table.appointment_list)",
            "trainer": "$t(course_table.trainer)",
            "places": "$t(course_table.places)",
            "event": "$t(course_table.event)",
            "from": "$t(course_table.from)",
            "to": "$t(course_table.to)",
            "offer": "$t(course_table.offer)",
            "price": "",
            "from_date_header": "$t(course_table.from_date_header)",
            "to_date_header": "$t(course_table.to_date_header)",
            "from_time": "$t(course_table.from_time)",
            "to_time": "$t(course_table.to_time)",
            "duration": "$t(course_table.duration)",
            "categories": "$t(course_table.categories)",
            "remaining": "$t(course_table.remaining)",
            "more_info": "$t(course_table.more_info)"
        },
        "format": {
            "free": "Free",
            "course_format": "$t(course_table.course_format)",
            "course_price": "$t(bookcart.course_price)",
            "course_price_plural": "$t(bookcart.course_price_plural)",
            "timespan_title": "{course1} {course2} { title } {fromDate} {fromTime} {price}",
            "timespan_format": "{course1} {course2} { title } {fromDate} {fromTime} {toDate} {toTime} {price} {placesLeft}",
            "from_to_auto": "{fromDate} {fromTime} {toDate} {toTime}",
            "from_to_time": "{fromTime} - {toTime}",
            "from_date_auto": "{fromDate} {fromTime} {toTime}",
            "from_date": "{fromDateAuto}",
            "to_date": "{toDate} {toTime}",
            "trainer_name": "{firstName} {lastName}",
            "no_data_to_display": "$t(bookcart.no_data_to_display)",
            "n_places_left": "{ count } place left",
            "n_places_left_plural": "{ count } places left",
            "price": "$t(bookcart.price)",
            "book_now": "Book now",
            "add_to_waiting_list": "Add to waiting list",
            "no_appointments": "No Appointments",
            "fully_booked": "Fully Booked"
        }
    },
    "course_filters": {
        "no_matching_categories": "No matching categories",
        "no_matching_courses": "No matching courses",
        "no_matching_places": "No matching locations",
        "no_matching_months": "No matching months",
        "places": "All Places",
        "courses": "All Events",
        "months": "All Months",
        "search": "Search",
        "trainers": "All Trainers",
        "category": "Sub category {position}",
        "category_zero": "Category"
    },
    "errors": {
        "required_with_label": "{ label } is required",
        "invalid_email": "Email is invalid",
        "invalid_date": "{name} is not a valid date",
        "emails_do_not_match": "Emails do not match",
        "values_do_not_match": "{confirmation_field_label} does not match {field_label}",
        "unexpected": "An unexpected error occurred.",
        "field_type_not_available": "Field {type} is not available"
    },
    "pay": {
        "show_more_price_info": "+ show more",
        "show_less_price_info": "- show less",
        "due_now": "<h4>{ price }</h4> Due now",
        "due_on": "<h4>{ price }</h4> Due on { due_date }",
        "due_now_net": "<h4>{ netPrice }</h4> Due now",
        "due_on_net": "<h4>{ netPrice }</h4> Due on { due_date }"
    },
    "paybook": {
        "recommended_payment_text": "Recommended",
        "payment_received": "Payment received",
        "voucher_payment": "Voucher {code}",
        "fully_paid_by_voucher": "Fully paid by voucher. There is nothing left to pay.",
        "fully_paid": "Fully paid. There is nothing left to pay.",
        "no_payment_due_now": "No payment is due now.",
        "pageDescription": "<h4>Please check and confirm your booking of {total} (includes {tax} VAT).</h4>",
        "pageDescriptionNet": "<h4>Please check and confirm your booking of {totalNet} (plus {tax} VAT).</h4>",
        "submit": "Submit",
        "back": "Back",
        "coupon_code": {
            "title": "Discount or voucher code",
            "placeholder": "Enter code",
            "error": "Something went wrong",
            "clear_code": "Clear",
            "apply_code": "Apply",
            "voucher_applied": "Voucher applied",
            "voucher_deduction": "Voucher deducted",
            "amount_due": "Amount due"
        }
    },
    "sepa_direct_debit": {
        "confirmButton": "Submit",
        "back": "back",
        "title": "Sepa Transfer",
        "description": ""
    },
    "outgoing_messages": {
        "title": "Messages"
    },
    "success_messages": {
        "title": ""
    },
    "success_actions": {
        "new_booking": "Create a new booking",
        "go_to_booking": "Go to booking",
        "checkin_bookings": "Check-in",
        "checkin_bookings_plural": "Check-in bookings"
    },
    "cancel_booking": {
        "timespan_title": "{course1} {course2} {title} {fromToAuto}",
        "from_to_auto": "$t(bookcart.from_to_auto)",
        "created_at": "Created at: { created_at }",
        "submit": "Cancel booking",
        "back": "Back"
    },
    "revoke_booking": {
        "name": "Name",
        "number": "Bill Number",
        "email": "E-Mail",
        "comment": "Message",
        "title": "Revoke Booking",
        "submit": "Revoke Booking",
        "back": "Back"
    },
    "test_sales": {}
}
